import {
  ArrowLeftOutlined,
  CloudUploadOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Tooltip,
  Typography,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import FormActions from "../../../organisms/FormActions";
import { useState } from "react";
import NotificationPreview from "./NotificationPreview";

const NotificationInfo = ({ form, formData, setFormData, setCurrentStep }) => {
  const [platform, setPlatform] = useState("android");

  const handleUploadImage = (info) => {
    const { status } = info.file;
    if (status === "done") {
      // message.success(`${info.file.name} file uploaded successfully.`);
      // generate preview URL
      const file = info.file.originFileObj;
      const previewUrl = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        notificationImage: file,
        notificationImagePreview: previewUrl,
      }));
    }
    // else if (status === "error") {
    //   message.error(`${info.file.name} file upload failed.`);
    // }
  };

  const beforeUpload = (file, field) => {
    if (field === "coverImage") {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE; // prevent upload
      }

      const isFileLessThan2Mb = file.size / 1024 / 1024 <= 50;
      if (!isFileLessThan2Mb) {
        message.error("Image must be smaller than 50MB!");
        return Upload.LIST_IGNORE; // prevent upload
      }

      return true; // allow upload
    }

    if (field === "notificationImage") {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return Upload.LIST_IGNORE; // prevent upload
      }

      // const isFileLessThan2Mb = file.size / 1024 / 1024 < 2;
      // if (!isFileLessThan2Mb) {
      //   message.error("Image must be smaller than 2MB!");
      //   return Upload.LIST_IGNORE; // prevent upload
      // }

      return true; // allow upload
    }
  };

  const handleNextStep = () => {
    form.validateFields().then((values) => {
      setCurrentStep((prev) => prev + 1);
    });
  };

  return (
    <Flex
      vertical
      gap={22}
      className="bg-color-white rounded shadow px-7 pt-6 pb-7 mb-[80px]"
    >
      <Flex justify="space-between" vertical={false}>
        <Flex vertical>
          <Typography.Title level={5}>Step 1</Typography.Title>
          <Typography.Title level={4} style={{ marginTop: "0" }}>
            Create Notification
          </Typography.Title>
        </Flex>
        <Flex gap={20}>
          <Button
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Flex>
      </Flex>

      <Row gutter={24}>
        <Col span={14}>
          <Flex
            vertical
            style={{
              border: "1px solid #E4E6EF",
              borderRadius: "12px",
            }}
          >
            <Typography.Text
              style={{
                marginTop: "0",
                fontSize: "14px",
                fontWeight: "500",
                padding: "24px",
              }}
            >
              Basic Information
            </Typography.Text>
            <Divider style={{ margin: "0" }} />
            <Form
              form={form}
              layout="vertical"
              // onValuesChange={(changedValues, allValues) => {
              //   if (changedValues.startDate || changedValues.endDate) {
              //     setFormData((prev) => ({
              //       ...prev,
              //       ...changedValues,
              //     }));
              //   }
              // }}
              style={{ padding: "24px" }}
            >
              <Form.Item
                label="Notification Title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Notification title is required",
                  },
                ]}
              >
                <Input
                  size="large"
                  showCount
                  maxLength={140}
                  placeholder="Enter notification title"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      title: e.target.value,
                    }))
                  }
                  //   disabled={isEditSurvey}
                />
              </Form.Item>

              <Form.Item label="Message" name="message">
                <Input.TextArea
                  size="large"
                  showCount
                  maxLength={500}
                  placeholder="Enter message"
                  rows={2}
                  value={formData.message}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      message: e.target.value,
                    }))
                  }
                  //   disabled={isEditSurvey}
                />
              </Form.Item>

              <Form.Item
                label="Direct to"
                name="notificationRedirectionType"
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={0}
              >
                <Radio.Group
                  className="flex-wrap"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      notificationRedirectionType: e.target.value,
                    }))
                  }
                  value={formData.notificationRedirectionType}
                >
                  <Radio value={0}>Application</Radio>
                  <Radio value={1}>External URL</Radio>
                </Radio.Group>
              </Form.Item>

              {form.getFieldValue("notificationRedirectionType") == 1 && (
                <Form.Item rules={[]} name="notificationRedirectionUrl">
                  <Input
                    size="large"
                    placeholder="Enter URL"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        notificationRedirectionUrl: e.target.value,
                      }))
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                label="Notification Image"
                name="notificationImageType"
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={0}
              >
                <Radio.Group
                  className="flex-wrap"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      notificationImageType: e.target.value,
                    }))
                  }
                  value={formData.notificationImageType}
                >
                  <Radio value={0}>No</Radio>
                  <Radio value={1}>Yes</Radio>
                </Radio.Group>
              </Form.Item>
              {form.getFieldValue("notificationImageType") == 1 && (
                <Form.Item
                  //   label="Promotional Survey Image"
                  name="notificationImagePreview"
                  rules={[
                    {
                      required: true,
                      message: "Promoter image is required",
                    },
                    {
                      validator(_, value) {
                        const isJpgOrPng =
                          value?.file?.type === "image/jpeg" ||
                          value?.file?.type === "image/png" ||
                          String(value).includes("jpeg") ||
                          String(value).includes("png");
                        if (!isJpgOrPng) {
                          return Promise.reject(
                            "Promoter image must be in PNG or JPG format"
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Dragger
                    onChange={(info) => handleUploadImage(info)}
                    beforeUpload={(file) => beforeUpload(file, "coverImage")}
                    accept=".png,.jpg,.jpeg"
                    listType="picture-card"
                    rootClassName="image"
                    name="image"
                    maxCount={1}
                    showUploadList={false}
                    customRequest={({ file, onSuccess }) => {
                      setTimeout(() => {
                        onSuccess("ok");
                      }, 1000);
                    }}
                    style={{
                      width: formData.notificationImagePreview
                        ? "fit-content"
                        : "inherit",
                    }}
                  >
                    {formData.notificationImagePreview ? (
                      <div className="relative group w-full h-full">
                        <img
                          src={formData.notificationImagePreview}
                          width={"100px"}
                          height={"100px"}
                          style={{
                            border: "1px solid #e4e6ef",
                            borderRadius: "8px",
                          }}
                        />
                        <Flex
                          className="absolute inset-0 items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                          style={{
                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                            borderRadius: "8px",
                            height: "100px",
                          }}
                        >
                          <EditOutlined
                            style={{ color: "white", fontSize: "24px" }}
                          />
                        </Flex>
                      </div>
                    ) : (
                      <>
                        <p className="ant-upload-drag-icon">
                          <CloudUploadOutlined />
                        </p>
                        <p className="ant-upload-text">
                          Click or drag file to this area to upload
                        </p>
                        <p className="ant-upload-hint">Maximum size: 5MB</p>
                      </>
                    )}
                  </Dragger>
                </Form.Item>
              )}
            </Form>
          </Flex>
        </Col>
        <Col span={10}>
          <Flex gap={16} vertical>
            <Typography.Text
              style={{
                fontSize: "14px",
                fontWeight: "500",
                display: "flex",
                gap: "4px",
              }}
            >
              Preview
              <Tooltip
                placement="bottom"
                title="This preview is just for representational purpose and the actual preview might differ"
              >
                <InfoCircleOutlined />
              </Tooltip>
            </Typography.Text>

            <NotificationPreview
              platform={platform}
              setPlatform={setPlatform}
              formData={formData}
            />
          </Flex>
        </Col>
      </Row>

      <FormActions
        actionButtons={[
          {
            id: 1,
            buttonType: "primary",
            buttonHTMLType: "submit",
            buttonText: "Next Step",
            handleButton: handleNextStep,
          },
        ]}
      />
    </Flex>
  );
};

export default NotificationInfo;
